import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';

export const EbsDialogBannerTexts = {
  heading: 'Как получить биометрию',
  description: `Для получения финансовых услуг подойдут и${UNBREAKABLE_SEPARATOR}стандартная, и подтверждённая биометрия — выберите,${UNBREAKABLE_SEPARATOR}какую${UNBREAKABLE_SEPARATOR}вам${UNBREAKABLE_SEPARATOR}удобнее${UNBREAKABLE_SEPARATOR}получить`,
  btnText: 'Все понятно',
};
